import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DeviceTypeState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: DeviceTypeState = {
  data: [],
  isLoading: false,
  error: null,
};

const deviceTypeSlice = createSlice({
  name: 'devices',
  initialState,
  reducers: {
    setDevices: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setDeviceTypeLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setDeviceTypeError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setDevices, setDeviceTypeLoading, setDeviceTypeError } = deviceTypeSlice.actions;

export default deviceTypeSlice.reducer;
